























import { Column } from '@/features/ui/table/model';
import { ArrayProp } from '@/util/prop-decorators';
import { Component, Vue } from 'vue-property-decorator';
import { createTreeNodeTypeComparator } from '@/features/domain-ui/tree-node-type/constants';
import { AttributeDefinitionTemplateRow } from './model';

@Component
export default class AttributeDefinitionTemplateTable extends Vue {
  @ArrayProp(() => [])
  private readonly attributeDefinitionTemplates!: AttributeDefinitionTemplateRow[];

  private readonly comparator = createTreeNodeTypeComparator('labelPlural');

  private readonly columns: Column[] = [
    { name: 'name', field: 'configuration.name', label: 'Name' },
    { name: 'type', field: 'configuration.__typename', label: 'Typ' },
    { name: 'description', field: 'configuration.description', label: 'Beschreibung' },
    { name: 'treeNodeTypes', field: 'configuration.treeNodeTypes', label: 'Anwendbar auf' },
    { name: 'addAttributeOnCustomerAdded', label: 'Automatisch anlegen?' },
    { name: 'actions', label: '' },
  ];
}
